import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import { FAILURE_LANDINGPAGE, REQUEST_LANDINGPAGE, SUCCESS_LANDINGPAGE } from 'src/store/welcome/actions';

function landingpageReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_LANDINGPAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_LANDINGPAGE: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_LANDINGPAGE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export default landingpageReducer;
